import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  MDBInput,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBTableHead,
  MDBTable,
  MDBTableBody,
  MDBSelect,
  MDBContainer,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
} from "mdbreact";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import {
  getRecurringBookings,
  cancelRecurringBooking,
} from "../../../actions/recurringAction";
import { getBookings } from "../../../actions/bookingAction";
import {
  displayBreadcrumbs,
  showHideLoader,
  toggleModal,
  showNotification,
} from "../../../actions";
import _ from "lodash";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "../shared/Modal";
import BookingManagement from "../shared/BookingManagement";
import { validateAccess } from "../../../helper/utils";

class ManageRecurring extends React.Component {
  state = {
    resultContainer: {},
    startDateFilter: "",
    endDateFilter: "",
    limitOptions: [],
    statusOptions: [],
    limit: "10",
    status: "",
    query: "",
    page: "1",
    activeItemOuterTabs: "1",
    activeItemInnerPills: "1",
    showBookingDetailsModal: false,
    loader: true,
    filterLoaded: false,
    total_bookings: 0,
  };

  debouncedDoFilter = _.debounce(function () {
    this.doFilter();
  }, 10);

  initLimitOptions() {
    let options = [
      {
        checked: false,
        disabled: false,
        text: "5",
        value: "5",
      },
      {
        checked: true,
        disabled: false,
        text: "10",
        value: "10",
      },
      {
        checked: false,
        disabled: false,
        text: "20",
        value: "20",
      },
      {
        checked: false,
        disabled: false,
        text: "25",
        value: "25",
      },
    ];

    this.setState({ limitOptions: options });
  }

  componentDidMount() {
    const { query } = this.state;

    this.props.showHideLoader(true);

    this.props.displayBreadcrumbs(
      "Dashboard / Administrator / Report / Recurring Bookings"
    );

    let params = {};

    this.initLimitOptions();
    this.initStatusOptions();

    this.props.getRecurringBookings(params, this.props.authUser.sessionToken);
  }

  render() {
    return (
      <div>

        {this.renderForm()}
        {this.renderTable()}
      </div>
    );
  }

  startDateFilterOnChange = (date) => {
    this.setState({
      startDateFilter: date,
    });
    this.debouncedDoFilter();
  };

  endDateFilterOnChange = (date) => {
    this.setState({
      endDateFilter: date,
    });
    this.debouncedDoFilter();
  };

  datePicker() {
    return (
      <span>
        <DatePicker
          className="custom-input"
          placeholderText="Select Start Date"
          selected={this.state.startDateFilter}
          onChange={this.startDateFilterOnChange}
          dateFormat="dd/MM/yyyy"
        />
      </span>
    );
  }

  endDatePicker() {
    return (
      <span>
        <DatePicker
          className="custom-input"
          placeholderText="Select End Date"
          selected={this.state.endDateFilter}
          onChange={this.endDateFilterOnChange}
          dateFormat="dd/MM/yyyy"
        />
      </span>
    );
  }

  getValueOfSelectStatus = (value) => {
    this.setState({ status: value[0] });
    this.debouncedDoFilter();
  };

  renderFilters() {
    const { limitOptions, statusOptions } = this.state;

    return (
      <div>
        <MDBRow className="mb-4">
          <MDBCol md="6">
            <h3 className="mt-3">Recurring Bookings</h3>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="3">
            <MDBRow>
              <MDBCol md="12">{this.datePicker()}</MDBCol>
              <MDBCol md="12" className="mt-2">
                {this.endDatePicker()}
              </MDBCol>
            </MDBRow>
          </MDBCol>
          <MDBCol md="3">
            <MDBRow>
              <MDBCol md="12" className="remove-margin-tb">
                <MDBSelect
                  outline
                  color="primary"
                  getValue={this.getValueOfSelectStatus}
                  options={statusOptions}
                  label="Status"
                />
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="2">
            <MDBSelect
              outline
              color="primary"
              getValue={this.getValueOfSelectLimit}
              value={this.state.limit}
              options={limitOptions}
              label="Show entries"
            />
          </MDBCol>
          <MDBCol md="10">
            <div className="float-right">
              <MDBInput
                label="Search recurring by keyword(s)."
                name="query"
                onChange={this.changeHandler}
                style={{ width: "430px" }}
              />
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.recurringBookingResponse !== this.props.recurringBookingResponse
    ) {
      let recurringBookingResponse = this.props.recurringBookingResponse;
      if (recurringBookingResponse.action == "ACTION") {
        this.props.showNotification(
          recurringBookingResponse.notificationType,
          recurringBookingResponse.data.message
        );
        if (
          recurringBookingResponse.status >= 200 &&
          recurringBookingResponse.status <= 300
        ) {
          this.doFilter();
        }
        this.props.showHideLoader(false);
      } else {
        this.props.showHideLoader(false);
        this.setState({
          resultContainer: this.props.recurringBookingResponse.data,
          page: this.props.recurringBookingResponse.data.page,
        });
      }
    }
  }

  showBookingModal(showRecurringBookingModal, source) {
    if (source !== null) {
      this.setState({
        showRecurringBookingModal: showRecurringBookingModal,
        bookingId: source.booking.id,
        bookingDetails: source,
        bookingReference: source.booking.reference,
      });
    } else {
      this.setState({
        showRecurringBookingModal: showRecurringBookingModal,
        isLoaded: false,
        bookingId: 0,
        bookingReference: null,
      });
    }
  }

  async getBookingTotal(parentBookingId) {
    this.state.isLoaded = true;
    const data = await this.props.getBookings(
      { limit: 1, parentBookingId: parentBookingId },
      this.props.authUser.sessionToken,
      false
    );
    this.state.total_bookings = data.data.bookings.total;
  }

  renderForm() {
    const {
      showRecurringBookingModal,
      bookingId,
      bookingReference,
      bookingDetails,
      isLoaded,
      total_bookings,
    } = this.state;
    if (showRecurringBookingModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    var booking_to = "Indefinite";
    var booking_from = "";
    if (bookingId != 0 && bookingId != undefined) {
      booking_from = moment(bookingDetails.booking.booking_from)
        .local()
        .format("DD/MM/YYYY");
      if (
        bookingDetails.end_date != "0000-00-00" &&
        bookingDetails.end_date != "" &&
        bookingDetails.end_date != "None"
      ) {
        booking_to = moment(bookingDetails.end_date).format("DD/MM/YYYY");
      }
      if (isLoaded == undefined || !isLoaded) {
        this.getBookingTotal(bookingId);
      }
    }
    return (
      <div>
        {bookingId != 0 && bookingId != undefined ? (
          <MDBModal
            isOpen={showRecurringBookingModal}
            size="xl"
            wrapClassName="scrollable"
            toggle={() => this.showBookingModal(false, null)}
          >
            <MDBModalHeader>
              Generated bookings for recurring booking {bookingReference}
            </MDBModalHeader>
            <MDBModalBody>
              <MDBRow>
                <MDBCol md="3" className="border-right">
                  <MDBTable responsive striped bordered>
                    <MDBTableHead>
                      <tr>
                        <th>Booking Informantion</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      <tr>
                        <td>
                          <strong>Name:</strong>{" "}
                          {bookingDetails.customer.fullname}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Mobile:</strong>{" "}
                          {bookingDetails.customer.mobile}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Email:</strong>{" "}
                          {bookingDetails.customer.email}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Start Date:</strong> {booking_from}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>End Date:</strong> {booking_to}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Total Bookings:</strong> {total_bookings}
                        </td>
                      </tr>
                    </MDBTableBody>
                  </MDBTable>
                </MDBCol>
                <MDBCol md="9" style={{ position: "relative" }}>
                  <BookingManagement
                    isView={false}
                    parentBookingId={bookingId}
                  />
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="secondary"
                onClick={() => this.showBookingModal(false, null)}
              >
                Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>
        ) : (
            <span></span>
          )}
      </div>
    );
  }

  renderTable() {
    const { resultContainer, page } = this.state;
    const { storeUserAccess } = this.props;
    const data = {
      columns: [
        {
          label: "Booking Reference",
          field: "reference",
          sort: "asc",
        },
        {
          label: "Customer",
          field: "customer",
          sort: "asc",
        },
        {
          label: "Recurring Type",
          field: "recurring_type",
          sort: "asc",
        },
        {
          label: "Start Date",
          field: "startDate",
          sort: "asc",
        },
        {
          label: "End Date",
          field: "endDate",
          sort: "asc",
        },
        {
          label: "Status",
          field: "status",
          sort: "asc",
        },
        {
          label: "Actions",
          field: "buttons",
          sort: "asc",
        },
      ],
    };

    let rows = [];
    if (typeof resultContainer.results !== "undefined") {
      rows = _.chain(resultContainer.results)
        .map((result, index) => {
          let booking = result.booking;
          let booking_date = moment(booking.from).local().format("DD/MM/YYYY");
          let startDate = booking_date;
          let endDate = result.end_date;

          if (
            endDate == null ||
            endDate == "" ||
            endDate == "None" ||
            endDate == "0000-00-00"
          ) {
            endDate = "Indefinite";
          } else {
            endDate = moment(endDate + "T13:00:00+00:00")
              .local()
              .format("DD/MM/YYYY");
          }

          let customer = result.customer;
          let booking_from = moment(booking.from).local().format("HH:mm");
          let booking_to = moment(booking.to).local().format("HH:mm");
          return {
            reference: (
              <span>
                {booking.reference}
                <br></br>
                {booking_date}
                <br></br>
                {booking_from} - {booking_to}
                <br></br>
              </span>
            ),
            customer: (
              <span>
                {customer.fullname}
                <br></br>
                {customer.mobile}
                <br></br>
                {customer.email}
                <br></br>
              </span>
            ),
            recurring_type: result.recurring_type,
            startDate: startDate,
            endDate: endDate,
            status: result.status,
            buttons: (
              <div>
                {result.status == "Active" &&
                  validateAccess(
                    storeUserAccess,
                    "RecurringBookings",
                    "cancelRecurring"
                  ) ? (
                    <MDBBtn
                      color="danger"
                      size="sm"
                      className="float-right"
                      onClick={() => this.confirmCancellation(result)}
                    >
                      Cancel Recurring
                    </MDBBtn>
                  ) : (
                    <span></span>
                  )}
                {validateAccess(
                  storeUserAccess,
                  "RecurringBookings",
                  "viewBookings"
                ) && (
                    <MDBBtn
                      style={{
                        marginTop: ".375rem",
                        marginBottom: ".375rem",
                        marginRight: ".375rem",
                        marginLeft: ".375rem",
                      }}
                      //href={bookingUrl}
                      onClick={() => this.showBookingModal(true, result)}
                      color="primary"
                      size="sm"
                      className="float-right"
                    >
                      View Bookings
                    </MDBBtn>
                  )}
              </div>
            ),
          };
        })
        .value();
      data["rows"] = rows;
      return (
        <MDBContainer>
          {this.renderFilters()}
          <MDBTable responsive striped bordered>
            <MDBTableHead columns={data.columns} />
            <MDBTableBody rows={data.rows} />
          </MDBTable>
          <MDBRow>
            <MDBCol md="12">
              {this.renderTotalResult()}
              <div className="float-right">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={resultContainer.totalPage}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={4}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      );
    }
    return <div></div>;
  }

  doCancelletaion() {
    const { recurringData } = this.state;
    this.props.showHideLoader(true);
    let params = {
      id: recurringData.booking.id,
      booking_reference: recurringData.booking.reference,
      status_id: recurringData.booking.status_id,
      organisation_id: recurringData.organisation.id,
      booking_reference: recurringData.booking.reference,
      statusNotes: "",
    };
    this.props.cancelRecurringBooking(
      params,
      recurringData.id,
      this.props.authUser.sessionToken
    );
    this.closeCancellationModal();
  }

  closeCancellationModal() {
    const modal = {
      isOpen: false,
    };
    this.props.toggleModal(modal);
  }

  confirmCancellation = (recurring) => {
    const modal = {
      isOpen: true,
      content: (
        <span>
          Are you sure you want to cancelled recurring for booking{" "}
          {recurring.booking.reference}?<br></br>
          <br></br>
          <span className="text-danger">
            By cancelling the recurring for the parent booking, any pending
            bookings will be cancelled.
          </span>
        </span>
      ),
      title: "Recurring Cancellation Confirmation.",
      negativeButtonText: "Cancel",
      positiveButtonText: "Proceed",
      positiveButtonColor: "danger",
      negativeButtonAction: this.closeCancellationModal.bind(this),
      positiveButtonAction: this.doCancelletaion.bind(this),
    };

    this.props.toggleModal(modal);

    this.setState({ recurringData: recurring });
  };

  getValueOfSelectLimit = (value) => {
    this.setState({ limit: value.length > 0 ? value[0] : "" });
    this.debouncedDoFilter();
  };

  renderTotalResult() {
    const { resultContainer } = this.state;
    if (typeof resultContainer.recurring_bookings !== "undefined") {
      return (
        <span>
          Showing{" "}
          {resultContainer.recurring_bookings.limit *
            resultContainer.recurring_bookings.page}{" "}
          of {resultContainer.recurring_bookings.total} result
        </span>
      );
    }
    return <span></span>;
  }

  doBookingFilter() {
    const { parentBookingId, page, limit, query } = this.state;
    this.props.showHideLoader(true);
    let params = {};
    if ((page + "").length > 0) {
      params["page"] = page;
    }
    if (limit.length > 0) {
      params["limit"] = limit;
    }
    if (parentBookingId !== undefined) {
      params["parentBookingId"] = parentBookingId;
    }

    this.props.getBookings(params, this.props.authUser.sessionToken);
  }

  initStatusOptions() {
    let options = [
      {
        checked: true,
        disabled: false,
        text: "Active",
        value: "Active",
      },
      {
        checked: false,
        disabled: false,
        text: "Inactive",
        value: "Inactive",
      },
    ];

    this.setState({ statusOptions: options });
  }

  doFilter() {
    const {
      startDateFilter,
      endDateFilter,
      status,
      page,
      limit,
      query,
    } = this.state;

    this.props.showHideLoader(true);

    let params = {};
    if (startDateFilter) {
      params["startDate"] = moment(startDateFilter).utc().format("YYYY-MM-DD");
    }

    if (endDateFilter) {
      params["endDate"] = moment(endDateFilter).utc().format("YYYY-MM-DD");
    }

    if (status !== undefined && status.length > 0) {
      params["status"] = status;
    }

    if ((page + "").length > 0) {
      params["page"] = page;
    }

    if (limit.length > 0) {
      params["limit"] = limit;
    }

    if (query !== undefined) {
      params["query"] = query;
    }

    this.props.getRecurringBookings(params, this.props.authUser.sessionToken);
  }

  changeHandler = (event) => {
    clearTimeout(this.state.timer);
    let timer = setTimeout(() => {
      this.debouncedDoFilter();
    }, 500);

    this.setState({
      ...this.state,
      timer: timer,
      [event.target.name]: event.target.value,
    });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected + 1;
    this.setState({
      page: selectedPage,
    });
    this.debouncedDoFilter();
  };
}

const mapStateToProps = (state) => {
  return {
    authUser: state.authUser,
    recurringBookingResponse: state.recurringBookingResponse,
    getBookingsSuccessResponse: state.getBookingsSuccessResponse,
    storeUserAccess: state.storeUserAccess,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    displayBreadcrumbs,
    showHideLoader,
    getRecurringBookings,
    getBookings,
    toggleModal,
    cancelRecurringBooking,
    showNotification,
  })(ManageRecurring)
);
